import React, { useEffect, useState } from "react";
import Header from "../../component/Header";
import { useSwal } from "../../component/sweetalert";
import api from "../../Services/api"; // Import Axios instance
import "../AddBlog/index.css";

export default function AddHashtags() {
  const [tally, setTally] = useState("");
  const [hashtags, setHashtags] = useState([]);
  const alert = useSwal();

  useEffect(() => {
    const fetchHashtags = async () => {
      try {
        const response = await api.post("/getAllHashtags");
        const data = response.data.data || [];
        setHashtags(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching hashtags:", error);
        setHashtags([]);
      }
    };

    fetchHashtags();
  }, []);

  // Add Hashtag
  const addHashtag = async (e) => {
  e.preventDefault();
  
  if (!tally) {
    alert("error", "Please enter a hashtag.");
    return;
  }

  const newHashtag = tally.trim();
  const normalizedHashtag = newHashtag.startsWith("#")
    ? newHashtag.toLowerCase()
    : `#${newHashtag.toLowerCase()}`;
  
  // Check if the hashtag already exists in the list
  if (hashtags.some((tag) => tag.Hashtags?.toLowerCase() === normalizedHashtag)) {
    alert("error", "Hashtag already exists!");
    return;
  }

  try {
    const response = await api.post("/insertHashtag", {
      Hashtags: newHashtag,
    });

    if (response.data.message !== "Hashtag inserted successfully") {
      alert("error", response.data.message || "Failed to add hashtag!");
      return;
    }

    setHashtags((prevHashtags) => [response.data.data, ...prevHashtags]);
    alert("success", "Hashtag added successfully!");
    setTally(""); // Clear input field
  } catch (error) {
    alert("error", "Failed to add hashtag!");
  }
};

  // Remove Hashtag on click
  const removeHashtag = async (hashtag) => {
    try {
      const response = await api.post(`/deleteHashtag/${hashtag.id}`);

      if (response.data.message !== "Hashtag deleted successfully") {
        alert("error", response.data.message || "Failed to delete hashtag!");
        return;
      }

      setHashtags((prevHashtags) =>
        prevHashtags.filter((item) => item.id !== hashtag.id)
      );
      alert("success", "Hashtag deleted successfully!");
    } catch (error) {
      alert("error", "Failed to delete hashtag!");
    }
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Create Hashtag" backTo="/blog-view" />
      <div className="pageLeftspace">
        {/* Form Section */}
        <div className="form-fields d-flex flex-column">
          <form className="d-flex gap-3" onSubmit={addHashtag}>
            <div className="grid-container hashtag">
              <div className="input-container hastage">
                <input
                  type="text"
                  id="name"
                  placeholder="Generator Hashtag"
                  value={tally}
                  onChange={(e) => setTally(e.target.value)}
                  required
                />
                <span className="underline"></span>
              </div>

              <button className="btn btn-purpal" type="submit">
                Generate
              </button>
            </div>
          </form>

          <div className="hashtag-list">
            {hashtags.map((tag) => (
              <span key={tag.id} className="hashtag-item">
                {tag.Hashtags}
                <button
                  className="remove-btn"
                  onClick={() => removeHashtag(tag)}
                >
                  &times;
                </button>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
